
// ส่ง array  ลำดับสมาชิกที่ต้องการลบ 
export default function isArrayInArray2D(source, search, field) {

    let newarr = []
    for (var i = 0, len = source.length; i < len; i++) {

        // console.log("settoTable", source[i][field],"::::::", search[0]['REFDOCNO']);
        if (source[i][field] !== search[0][field]) {
            newarr.push(source[i])
        }
    }
    return newarr;
}



